import Dialog from "@src/components/dialogs/Dialog";
import { useEffect, useMemo, useState } from "react";
import { ViewManager } from "../ViewManager";
import { Grid } from "../../Grid";
import { DatasetControl } from "@talxis/base-controls";
import { Context } from "@src/ComponentFramework/PropertyClasses/Context";
import { ThemeDefinition } from "@src/app/classes/definitions/ThemeDefinition";
import { IDialogProps } from "@fluentui/react";
import { getViewManagerDialogStyles } from "./styles";
import React from "react";
import { Grid as GridControl } from '@talxis/base-controls';
import { useRerender } from "@talxis/react-components";

interface IViewManagerDialog extends IDialogProps {
    grid: Grid
}

const MemoizedDatasetControl = React.memo(DatasetControl);

export const ViewManagerDialog = (props: IViewManagerDialog) => {

    const [viewManagerInitialized, setViewManagerInitialized] = useState(false);
    const viewManager = useMemo(() => new ViewManager(props.grid, () => setViewManagerInitialized(true)), []);
    const rerender = useRerender();
    const styles = useMemo(() => getViewManagerDialogStyles(), []);

    const onInit = () => {
        viewManager.dataset.addEventListener('onRecordColumnValueChanged', () => {
            rerender();
        });
        setViewManagerInitialized(true);
    };

    useEffect(() => {
        onInit();
    }, [viewManagerInitialized]);

    return <Dialog
        dialogContentProps={{
            title: window.TALXIS.Portal.Translations.getLocalizedString("@pages/control/View/ViewSelector/ManageViews"),
            className: styles.dialogContent
        }}
        modalProps={{
            isBlocking: true,
            layerProps: {
                eventBubblingEnabled: true
            }
        }}
        height={600}
        width={600}
        maxWidth={600}
        hidden={false}
        {...props}
    >
        {viewManagerInitialized &&
            (() => {
                return <MemoizedDatasetControl
                    onGetDatasetControlInstance={() => viewManager.getDatasetControlInstance()}
                    onGetControlComponent={(props) => {
                        return <GridControl
                            {...props}
                        />;
                    }}
                />;
            })()
        }
    </Dialog>;
};